import { apiRequest } from '../http.js'

export const superAdminsApi = {
getAll: async (options = {}) => {
      const data = await apiRequest('/super-admins', options)
      return Array.isArray(data) ? data : []
    },
    invite: async (email) => {
      return apiRequest('/super-admins/invite', {
        method: 'POST',
        body: JSON.stringify({ email: email?.trim?.() || email }),
      })
    },
    remove: async (id, options = {}) => {
      await apiRequest(`/super-admins/${id}`, { ...options, method: 'DELETE' })
    },
}
